angular.module('unergie.main')
.directive('scrollBottom', ($timeout) =>
    ({
        scope: {
            scrollBottom: '=',
        },
        link($scope, $element) {
            if (_.isArray($scope.scrollBottom)) {
                $scope.$watchCollection('scrollBottom', (newValue) => {
                    if (newValue) {
                        return $timeout(() => $element.scrollTop($element[0].scrollHeight), 0)
                    }
                })
            } else {
                $scope.$watchCollection('scrollBottom.array', (newValue) => {
                    if (newValue && $scope.scrollBottom.switch) {
                        return $timeout(() => $element.scrollTop($element[0].scrollHeight), 0)
                    }
                })
            }
        },
    }),
)
